import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {makeSizeConstants} from '../../../../libs/shared/ui/src/styles/styleHelpers';

/*
 * Constants.
 */

const imgSizes = makeSizeConstants(12, 16, 24, 30);

/*
 * Props.
 */

interface ApplicationCardImageAvatarProps {
  url: string;
  size?: VisualSizesEnum;
}

/*
 * Style.
 */

interface StyledAvatarDivProps {
  $width: number;
  $height: number;
  $imgUrl: string;
}

const StyledAvatarDiv = styled.div<StyledAvatarDivProps>`
  align-self: center;
  overflow: hidden;
  border-radius: 150px;
  background-color: ${(p) => p.theme.foreground};

  ${(p) => css`
    width: ${p.$width}px;
    height: ${p.$height}px;
    background: url(${p.$imgUrl});
    background-position: center;
    background-size: contain;
  `}
`;

/*
 * Component.
 */

export const ApplicationCardImageAvatar: FC<ApplicationCardImageAvatarProps> = (props) => {
  const {url, size = VisualSizesEnum.EXTRA_LARGE} = props;
  return (
    <StyledAvatarDiv
      $height={imgSizes[size]}
      $width={imgSizes[size]}
      $imgUrl={url.endsWith('icon') ? url : `${url}card.svg`}
    />
  );
};
